import { method } from "./apiRequest";

export const userLogin = async({usr,pwd}) => {
    const formData = new FormData();
    formData.append('usr', usr);
    formData.append('pwd', pwd);
    const res = await method.login(formData);
    return res.data;
}
